import styled, { css } from 'styled-components';
import { alpha } from 'utils/ui/colors';
import { pxToRem } from 'utils/ui/units';
import { breakpoints, spacing, maxPageWidth } from 'styles/globals';
var constantClassName = 'PageSection';
var PageSection = styled.section.attrs({
  className: constantClassName
}).withConfig({
  displayName: "PageSection",
  componentId: "sc-14fwo0u-0"
})(["width:100%;max-width:", ";margin:0 auto;padding:", " ", ";@media (min-width:", "){padding-left:", ";padding-right:", ";}@media (min-width:", "){padding-left:", ";padding-right:", ";}.", " + &{padding-top:0;}", " ", " ", ""], function (p) {
  return pxToRem(p.maxWidth || maxPageWidth);
}, spacing.l, spacing.xs, breakpoints.xs, spacing.s, spacing.s, breakpoints.s, spacing.l, spacing.l, constantClassName, function (p) {
  return p.flush && css(["padding-top:0;padding-bottom:0;"]);
}, function (p) {
  return p.border && css(["border-", ":1px solid ", ";"], p.border, alpha(p.theme.shade, p.theme.lineStrength));
}, function (p) {
  return p.center && css(["text-align:center;"]);
});
export default PageSection;